enum AlignmentsBitOffsets {
  Top,
  Middle,
  Bottom,
  Left,
  Center,
  Right,
}

export enum Alignments {
  Top = 0x1 << AlignmentsBitOffsets.Top,
  Middle = 0x1 << AlignmentsBitOffsets.Middle,
  Bottom = 0x1 << AlignmentsBitOffsets.Bottom,
  Left = 0x1 << AlignmentsBitOffsets.Left,
  Center = 0x1 << AlignmentsBitOffsets.Center,
  Right = 0x1 << AlignmentsBitOffsets.Right,
  TopLeft = Top | Left,
  TopCenter = Top | Center,
  TopRight = Top | Right,
  MiddleLeft = Middle | Left,
  MiddleCenter = Middle | Center,
  MiddleRight = Middle | Right,
  BottomLeft = Bottom | Left,
  BottomCenter = Bottom | Center,
  BottomRight = Bottom | Right,
  Vertical = Top | Middle | Bottom,
  Horizontal = Left | Center | Right,
}
